import { CSSProperties, FunctionComponent, useContext, useEffect, useState } from "react";
import Image from "next/legacy/image";
import { useTranslation } from "next-i18next/pages";
import { useInView } from "react-intersection-observer";
import AppContext from "context/AppContext";
import styles from "../../styles/about/Companies.module.css";

interface Company {
  logoUrl: string;
  name: string;
  info: string;
}

interface CompaniesProps { }

const Companies: FunctionComponent<CompaniesProps> = () => {
  const { isMobile } = useContext(AppContext);
  const { t } = useTranslation("about");
  const companies: Company[] = t("companies.all", { returnObjects: true }) as Company[];
  const [isAnimationOn, setIsAnimationOn] = useState<boolean>(false);
  const { ref, inView } = useInView({ rootMargin: "0% 0% -5%" });

  useEffect(() => {
    if (inView) {
      setIsAnimationOn(true);
    }
  }, [inView]);

  return (
    <section className={`${styles.comapniesContainer} ${isAnimationOn && !isMobile ? styles.animated : ""}`} ref={ref}>
      <h3 className={styles.title}>{t("companies.title")}</h3>

      <main className={styles.companies}>
        {
          companies.map((company: Company, index: number) => {
            const style = { "--animation-delay": `${index === 0 ? 0.5 : 0.5 + index / 5}s` } as CSSProperties;

            return (
              <div key={index} className={styles.company} style={style}>
                <div className={styles.companyImg}>
                  <Image src={company.logoUrl} layout="fill" objectFit="contain" alt={`${company.name} logo image`} />
                </div>

                <div className={styles.companyInfo}>{company.info}</div>
              </div>
            );
          })
        }
      </main>
    </section>
  );
};

export default Companies;
